import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-legal-popups',
  templateUrl: './legal-popups.component.html',
  styleUrls: ['./legal-popups.component.scss']
})
export class LegalPopupsComponent {
  @Input() popup: string | null = null;
  @Output() close = new EventEmitter<void>();

  currentYear = new Date().getFullYear();

  closePopup(): void {
    this.close.emit();
  }
}
